import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'

import './plugins/element.js'
import './plugins/zhiwi.js'

import Vant from 'vant'
import 'vant/lib/index.css' // 必须引入样式！
Vue.use(Vant)

// 公共js
import "./utils/reset";

// element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// import 'jiantest666/jiantest.css'

// import jianbutton from 'jiantest666'
// Vue.use(jianbutton)
// import jianinput from 'jiantest666'
// Vue.use(jianinput)


import jiantest666 from 'jiantest666'
Vue.use(jiantest666)

// import { jianbutton } from 'jiantest666';
// Vue.component(jianbutton.name, jianbutton);



import router from './router'

import Print from 'vue-print-nb'
Vue.use(Print)

import store from './store'

//md5加密
import md5 from 'js-md5'
Vue.prototype.$md5 = md5
//xml转json
import X2js from 'x2js'
Vue.prototype.$x2js = new X2js()

//编辑器
import QuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.snow.css'
// 复制文本
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;
Vue.use(QuillEditor)



Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
